export class CityModel {
    public id: number;
    public name: string;
   

    constructor(obj: any) {
        this.id = obj.id ? obj.id : 0;
        this.name = obj.name ? obj.name : '';
      

    }
}
